import type { QueryClient, QueryKey } from '@tanstack/react-query';
import { sessionRevision, sessionScope, sessionTenantId } from '@/features/auth/session-scope';
import { useAuthStore } from '@/store/auth-store';
export const hostAppKeys = {
  list: (kind: 'all' | 'workspace', scope = sessionScope(useAuthStore.getState())) => ['apps', kind, scope] as const,
  conversation: (id: string | undefined, scope = sessionScope(useAuthStore.getState())) => ['conversation-apps', id, scope] as const,
  channel: (id: string | undefined, scope = sessionScope(useAuthStore.getState())) => ['channel-apps', id, scope] as const,
};

export const managementAppKeys={
 authority:(scope=sessionScope(useAuthStore.getState()))=>['app-management','authority',scope]as const,
 catalog:(scope=sessionScope(useAuthStore.getState()))=>['app-management','catalog',scope]as const,
 channels:(scope=sessionScope(useAuthStore.getState()))=>['app-management','channels',scope]as const,
 installations:(id:string|undefined,scope=sessionScope(useAuthStore.getState()))=>['app-installations',id,scope]as const,
};

export function currentHostAppKey(key: QueryKey, scope = sessionScope(useAuthStore.getState())): boolean {
  return scope !== 'anonymous' && key.length === 3 && key[2] === scope &&
    (key[0] === 'app-management' && ['authority','catalog','channels'].includes(String(key[1])) || key[0] === 'app-installations' && typeof key[1] === 'string' || key[0] === 'apps' && (key[1] === 'all' || key[1] === 'workspace') ||
      (key[0] === 'conversation-apps' || key[0] === 'channel-apps') && typeof key[1] === 'string');
}
const uuid = (value: unknown): value is string => typeof value === 'string' && /^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(value) && value !== '00000000-0000-0000-0000-000000000000';
export function ownedAppCatalogHint(value: unknown, envelopeTenant?: unknown): boolean {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const data = value as Record<string, unknown>, tenant = sessionTenantId(useAuthStore.getState());
  return uuid(tenant) && data.tenant_id === tenant && (envelopeTenant === undefined || envelopeTenant === tenant) && uuid(data.app_id) && (data.channel_id === undefined || uuid(data.channel_id));
}
/** Restart pre-hint GETs, then reread only this owner. No session POST here. */
export async function reconcileHostApps(client: QueryClient): Promise<void> {
  const revision = sessionRevision(), scope = sessionScope(useAuthStore.getState());
  if (scope === 'anonymous') return;
  const predicate = (query: { queryKey: QueryKey }) => currentHostAppKey(query.queryKey, scope);
  await client.cancelQueries({ predicate });
  if (revision !== sessionRevision()) return;
  await client.invalidateQueries({ predicate }, { cancelRefetch: false });
}
